<div theme>
  <div [ngClass]="{ invalid: !!error }">
    <dxc-checkbox
      [checked]="checked"
      [value]="value()"
      [label]="label()"
      [labelPosition]="labelPosition()"
      [name]="name()"
      [disabled]="disabled"
      [required]="required"
      [tabIndexValue]="tabIndexValue"
      [margin]="margin()"
      [size]="size()"
      [id]="id()"
      (onChange)="onChangeHandler($event)"
    >
    </dxc-checkbox>
  </div>
  @if (error) {
    <p class="checkBox-errorMsg text-danger">{{ error | translate }}</p>
  }
</div>
